import { render, staticRenderFns } from "./CaseLogs.vue?vue&type=template&id=841d5be4&scoped=true&"
import script from "./CaseLogs.vue?vue&type=script&lang=js&"
export * from "./CaseLogs.vue?vue&type=script&lang=js&"
import style0 from "./CaseLogs.vue?vue&type=style&index=0&id=841d5be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841d5be4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})
